import {
  Box,
  Text,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Button,
} from "grommet";
import { PSHRAByStatus } from "../graphql/queries";
import { useState, useEffect } from "react";
import { API } from "aws-amplify";
import { UpdatePSHRAExam } from "../graphql/mutations";

export default function PSHRA() {
  const [exams, setExams] = useState(null);
  const [selectedExam, setSelectedExam] = useState(null);

  function parseExamCode(examCode) {
    if (!examCode) return "";

    // Split by the pipe character and take the first part
    const parts = examCode.split("|");
    if (parts.length === 0 || !parts[0]) {
      return examCode; // Return original if no parts or first part is empty
    }

    const codePart = parts[0];

    // Extract the prefix (letters) and numbers
    const match = codePart.match(/^([A-Z]+)(\d+)$/);
    if (!match) return examCode; // Return original if pattern doesn't match

    const [, prefix, numbers] = match;

    // Split the numbers into groups of 3
    const formattedNumbers = numbers.match(/.{1,3}/g).join("-");

    return `${prefix}-${formattedNumbers}`;
  }

  useEffect(() => {
    getExams();
  }, []);

  async function getExams() {
    const data = await API.graphql({
      query: PSHRAByStatus,
      variables: {
        status: "QUEUE",
      },
    });
    console.log(data);
    setExams(data.data.pshraByStatus.items);
  }

  async function finishExam() {
    try {
      const data = await API.graphql({
        query: UpdatePSHRAExam,
        variables: {
          input: {
            session_id: selectedExam.session_id,
            status: "FINISHED",
          },
        },
      });
      console.log(data);

      if (!data.data.updatePSHRAExam.errors) {
        setSelectedExam(null);
        getExams();
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Box width="full" gap="medium">
      <Text textAlign="center" size="large" weight="bold">
        PSHRA Exam Codes
      </Text>
      <Box direction="row" gap="medium" width="full">
        <Box width="1/2" gap="medium" justify="start" align="start">
          <Text>Queue</Text>
          {exams && exams.length > 0 && (
            <>
              {exams.map((exam) => (
                <Card key={exam.session_id} width="full" pad="small">
                  <CardBody>
                    <Box
                      width="full"
                      direction="column"
                      gap="small"
                      justify="center"
                    >
                      <Box>
                        <Text weight="bold">Name:</Text>
                        <Text>
                          {exam.first_name} {exam.last_name}
                        </Text>
                      </Box>
                      <Box>
                        <Text weight="bold">Email:</Text>
                        <Text>{exam.email}</Text>
                      </Box>
                      <Box>
                        <Text weight="bold">iMIS ID:</Text>
                        <Text>{exam.iMIS_id}</Text>
                      </Box>
                    </Box>
                    <Box>
                      <Text weight="bold">Exam Name:</Text>
                      <Text>{exam.exam_name}</Text>
                    </Box>
                    <CardFooter>
                      <Button
                        label="Select"
                        onClick={() => setSelectedExam(exam)}
                        primary
                      />
                    </CardFooter>
                  </CardBody>
                </Card>
              ))}
            </>
          )}
        </Box>
        <Box width="full" gap="medium" justify="start" align="center">
          <Box height="xxsmall" />
          {selectedExam && (
            <Card width="full" pad="small" align="center" justify="center">
              <CardHeader>
                <Box direction="row" gap="medium" justify="between">
                  <Text weight="bold" size="large">
                    {selectedExam.first_name} {selectedExam.last_name}
                  </Text>
                  <Text weight="bold" size="large">
                    {selectedExam.email}
                  </Text>
                </Box>
              </CardHeader>
              <CardBody margin={{ top: "medium" }}>
                <Box direction="row" gap="medium" wrap>
                  <Text weight="bold">iMIS ID: </Text>
                  <Text>{selectedExam.iMIS_id}</Text>
                  <Text weight="bold">Exam: </Text>
                  <Text>{selectedExam.exam_name}</Text>
                  <Text weight="bold">Exam Code: </Text>
                  <Text>{parseExamCode(selectedExam.exam_code)}</Text>
                </Box>
              </CardBody>
              <CardFooter margin={{ top: "medium" }}>
                <Button label="Finish Tester" onClick={finishExam} />
              </CardFooter>
            </Card>
          )}
        </Box>
      </Box>
    </Box>
  );
}
